import $ from "jquery";

export default function productImages() {
    $(".product-images").each(function () {
        const $images = $(this),
            $imagesChildren = $images.children(),
            $preview = $('<div class="product-images-preview"></div>').appendTo($images),
            $nav = $('<div class="product-images-nav"></div>').appendTo($images);
        
        if ($imagesChildren.length > 1) {
            $imagesChildren.appendTo($preview).clone().appendTo($nav);
            
            $preview.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                swipe: false,
                fade: true,
                asNavFor: ".product-images-nav",
            });
            $nav.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                asNavFor: ".product-images-preview",
            });
            
            $nav.find(".slick-slide").each(function () {
                $(this).on("click", () => {
                    $preview.slick('slickGoTo', $(this).data('slick-index'));
                });
            });
        }
    });
}
